"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoType = void 0;
const getVideoType = url => {
  const extension = url.split('.').pop();
  switch (extension) {
    case 'mp4':
      return 'video/mp4';
    case 'ogg':
      return 'video/ogg';
    case 'webm':
      return 'video/webm';
    default:
      return 'video/mp4';
    // default to mp4 if extension is not recognized
  }
};
exports.getVideoType = getVideoType;